module.exports = __webpack_public_path__ + "static/media/pacltw3.efee61e3.png";